import z from "zod/v4";

export const MaybeArray = <A>(schema: z.ZodType<A, A>) =>
  z.codec(z.union([schema, z.array(schema)]), z.array(schema), {
    decode: (v) => (Array.isArray(v) ? v : [v]),
    encode: (arr) => arr,
  });
